import React from "react";

const SingleBio = ({ about }) => {


  return (
    <div className="bio-container">
      <div
        className="bio-image-container"
        data-aos="fade-right"
        data-aos-duration="1200"
      >
        <img src={about.image} alt={about.alt} />
      </div>
      <div className="bio-container-text">
        <h2>{about.header}</h2>
        <h4>{about.subheading}</h4>
        <h5>{about.credential}</h5>
        <span className="hr-line"></span>
        <p>{about.content}</p>
      </div>
    </div>
  );
};

export default SingleBio;
